"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.upgrade.title': '账户升级',
    'account.upgrade.currentGrade': '当前账户级别',
    'account.upgrade.selectGrade': '您的套餐',
    'account.upgrade.save': '保存更改',
    'account.upgrade.payNow': '立即付款并升级',
    'account.upgrade.downgrade': '切换到更低价格计划',
    'account.upgrade.mostPopular': '最受欢迎',
    'account.upgrade.selectPlan': '选择计划',
    'account.upgrade.selected': '已选择',
    'account.upgrade.success': '账户级别更新成功',
    'account.upgrade.paymentInitiated': '已发起付款。请完成付款以升级您的账户。',
    'account.upgrade.errors.general': '无法更新账户级别',
    'account.upgrade.errors.loadUser': '无法加载用户信息',
    'account.upgrade.errors.noUser': '未找到用户',
    'account.upgrade.credits': '积分',
    'account.upgrade.noCredits': '不包含积分',
    'account.upgrade.perMonth': '每月',
    'account.upgrade.changePlan': '更改计划',
    'account.upgrade.currentPlan': '当前计划',
    'account.upgrade.futureGradeInfo': '此计划将激活于',
    'account.upgrade.confirm.title': '确认计划变更',
    'account.upgrade.confirm.downgrade': '您确定要降级到免费计划吗？您将失去对高级功能的访问权限。',
    'account.upgrade.confirm.change': '您确定要将计划更改为',
    'account.upgrade.success.changed': '您的计划已成功更改',
    'account.upgrade.success.upgraded': '账户升级成功！',
    'account.upgrade.errors.changeFailed': '更改计划失败',
    'account.upgrade.errors.paymentFailed': '付款失败。请再试一次。',
    'account.upgrade.monthly': '月付',
    'account.upgrade.yearly': '年付',
    'account.upgrade.saveMore': '节省更多',
    'account.upgrade.discount': '优惠',
    'account.upgrade.save_money_amount': '节省',
};
